import { render } from "./DynamicSideTab.vue?vue&type=template&id=35194770&scoped=true"
import script from "./DynamicSideTab.vue?vue&type=script&lang=js"
export * from "./DynamicSideTab.vue?vue&type=script&lang=js"

import "./DynamicSideTab.vue?vue&type=style&index=0&id=35194770&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35194770"]])

export default __exports__